module.exports = __webpack_public_path__ + "lp/img/folder_icon.1a1db299.svg";